module.exports = __webpack_public_path__ + "static/media/CompanyRankings_blurry.1e1208b9.jpg";